export default __webpack_public_path__ + "static/media/deer.8a5f935a.png";